export const wikiList = [
  {
    lang: "English",
    nativeLang: "English",
    code: "en",
  },
  {
    lang: "Cebuano",
    nativeLang: "Cebuano",
    code: "ceb",
  },
  {
    lang: "German",
    nativeLang: "Deutsch",
    code: "de",
  },
  {
    lang: "French",
    nativeLang: "français",
    code: "fr",
  },
  {
    lang: "Swedish",
    nativeLang: "svenska",
    code: "sv",
  },
  {
    lang: "Dutch",
    nativeLang: "Nederlands",
    code: "nl",
  },
  {
    lang: "Russian",
    nativeLang: "русский",
    code: "ru",
  },
  {
    lang: "Spanish",
    nativeLang: "español",
    code: "es",
  },
  {
    lang: "Italian",
    nativeLang: "italiano",
    code: "it",
  },
  {
    lang: "Egyptian Arabic",
    nativeLang: "مصرى",
    code: "arz",
  },
  {
    lang: "Polish",
    nativeLang: "polski",
    code: "pl",
  },
  {
    lang: "Japanese",
    nativeLang: "日本語",
    code: "ja",
  },
  {
    lang: "Chinese",
    nativeLang: "中文",
    code: "zh",
  },
  {
    lang: "Ukrainian",
    nativeLang: "українська",
    code: "uk",
  },
  {
    lang: "Vietnamese",
    nativeLang: "Tiếng Việt",
    code: "vi",
  },
  {
    lang: "Waray",
    nativeLang: "Winaray",
    code: "war",
  },
  {
    lang: "Arabic",
    nativeLang: "العربية",
    code: "ar",
  },
  {
    lang: "Portuguese",
    nativeLang: "português",
    code: "pt",
  },
  {
    lang: "Persian",
    nativeLang: "فارسی",
    code: "fa",
  },
  {
    lang: "Catalan",
    nativeLang: "català",
    code: "ca",
  },
  {
    lang: "Serbian",
    nativeLang: "српски / srpski",
    code: "sr",
  },
  {
    lang: "Indonesian",
    nativeLang: "Bahasa Indonesia",
    code: "id",
  },
  {
    lang: "Korean",
    nativeLang: "한국어",
    code: "ko",
  },
  {
    lang: "Norwegian",
    nativeLang: "norsk",
    code: "no",
  },
  {
    lang: "Chechen",
    nativeLang: "нохчийн",
    code: "ce",
  },
  {
    lang: "Finnish",
    nativeLang: "suomi",
    code: "fi",
  },
  {
    lang: "Turkish",
    nativeLang: "Türkçe",
    code: "tr",
  },
  {
    lang: "Czech",
    nativeLang: "čeština",
    code: "cs",
  },
  {
    lang: "Hungarian",
    nativeLang: "magyar",
    code: "hu",
  },
  {
    lang: "Tatar",
    nativeLang: "татарча / tatarça",
    code: "tt",
  },
  {
    lang: "Serbo-Croatian",
    nativeLang: "srpskohrvatski / српскохрватски",
    code: "sh",
  },
  {
    lang: "Romanian",
    nativeLang: "română",
    code: "ro",
  },
  {
    lang: "Min Nan Chinese",
    nativeLang: "Bân-lâm-gú",
    code: "zh-min-nan",
  },
  {
    lang: "Basque",
    nativeLang: "euskara",
    code: "eu",
  },
  {
    lang: "Malay",
    nativeLang: "Bahasa Melayu",
    code: "ms",
  },
  {
    lang: "Esperanto",
    nativeLang: "Esperanto",
    code: "eo",
  },
  {
    lang: "Hebrew",
    nativeLang: "עברית",
    code: "he",
  },
  {
    lang: "Armenian",
    nativeLang: "հայերեն",
    code: "hy",
  },
  {
    lang: "Danish",
    nativeLang: "dansk",
    code: "da",
  },
  {
    lang: "Bulgarian",
    nativeLang: "български",
    code: "bg",
  },
  {
    lang: "Welsh",
    nativeLang: "Cymraeg",
    code: "cy",
  },
  {
    lang: "Uzbek",
    nativeLang: "oʻzbekcha / ўзбекча",
    code: "uz",
  },
  {
    lang: "Slovak",
    nativeLang: "slovenčina",
    code: "sk",
  },
  {
    lang: "Simple English",
    nativeLang: "Simple English",
    code: "simple",
  },
  {
    lang: "South Azerbaijani",
    nativeLang: "تۆرکجه",
    code: "azb",
  },
  {
    lang: "Estonian",
    nativeLang: "eesti",
    code: "et",
  },
  {
    lang: "Belarusian",
    nativeLang: "беларуская",
    code: "be",
  },
  {
    lang: "Kazakh",
    nativeLang: "қазақша",
    code: "kk",
  },
  {
    lang: "Greek",
    nativeLang: "Ελληνικά",
    code: "el",
  },
  {
    lang: "Minangkabau",
    nativeLang: "Minangkabau",
    code: "min",
  },
  {
    lang: "Croatian",
    nativeLang: "hrvatski",
    code: "hr",
  },
  {
    lang: "Lithuanian",
    nativeLang: "lietuvių",
    code: "lt",
  },
  {
    lang: "Galician",
    nativeLang: "galego",
    code: "gl",
  },
  {
    lang: "Urdu",
    nativeLang: "اردو",
    code: "ur",
  },
  {
    lang: "Azerbaijani",
    nativeLang: "azərbaycanca",
    code: "az",
  },
  {
    lang: "Slovenian",
    nativeLang: "slovenščina",
    code: "sl",
  },
  {
    lang: "Ladin",
    nativeLang: "Ladin",
    code: "lld",
  },
  {
    lang: "Georgian",
    nativeLang: "ქართული",
    code: "ka",
  },
  {
    lang: "Norwegian Nynorsk",
    nativeLang: "norsk nynorsk",
    code: "nn",
  },
  {
    lang: "Tamil",
    nativeLang: "தமிழ்",
    code: "ta",
  },
  {
    lang: "Thai",
    nativeLang: "ไทย",
    code: "th",
  },
  {
    lang: "Hindi",
    nativeLang: "हिन्दी",
    code: "hi",
  },
  {
    lang: "Bangla",
    nativeLang: "বাংলা",
    code: "bn",
  },
  {
    lang: "Macedonian",
    nativeLang: "македонски",
    code: "mk",
  },
  {
    lang: "Latin",
    nativeLang: "Latina",
    code: "la",
  },
  {
    lang: "Cantonese",
    nativeLang: "粵語",
    code: "zh-yue",
  },
  {
    lang: "Asturian",
    nativeLang: "asturianu",
    code: "ast",
  },
  {
    lang: "Latvian",
    nativeLang: "latviešu",
    code: "lv",
  },
  {
    lang: "Afrikaans",
    nativeLang: "Afrikaans",
    code: "af",
  },
  {
    lang: "Tajik",
    nativeLang: "тоҷикӣ",
    code: "tg",
  },
  {
    lang: "Burmese",
    nativeLang: "မြန်မာဘာသာ",
    code: "my",
  },
  {
    lang: "Malagasy",
    nativeLang: "Malagasy",
    code: "mg",
  },
  {
    lang: "Albanian",
    nativeLang: "shqip",
    code: "sq",
  },
  {
    lang: "Marathi",
    nativeLang: "मराठी",
    code: "mr",
  },
  {
    lang: "Bosnian",
    nativeLang: "bosanski",
    code: "bs",
  },
  {
    lang: "Telugu",
    nativeLang: "తెలుగు",
    code: "te",
  },
  {
    lang: "Occitan",
    nativeLang: "occitan",
    code: "oc",
  },
  {
    lang: "Breton",
    nativeLang: "brezhoneg",
    code: "br",
  },
  {
    lang: "Belarusian (Taraškievica orthography)",
    nativeLang: "беларуская (тарашкевіца)",
    code: "be-tarask",
  },
  {
    lang: "Malayalam",
    nativeLang: "മലയാളം",
    code: "ml",
  },
  {
    lang: "Low German",
    nativeLang: "Plattdüütsch",
    code: "nds",
  },
  {
    lang: "Swahili",
    nativeLang: "Kiswahili",
    code: "sw",
  },
  {
    lang: "Kyrgyz",
    nativeLang: "кыргызча",
    code: "ky",
  },
  {
    lang: "Kurdish",
    nativeLang: "kurdî",
    code: "ku",
  },
  {
    lang: "Lombard",
    nativeLang: "lombard",
    code: "lmo",
  },
  {
    lang: "Javanese",
    nativeLang: "Jawa",
    code: "jv",
  },
  {
    lang: "Newari",
    nativeLang: "नेपाल भाषा",
    code: "new",
  },
  {
    lang: "Western Punjabi",
    nativeLang: "پنجابی",
    code: "pnb",
  },
  {
    lang: "Venetian",
    nativeLang: "vèneto",
    code: "vec",
  },
  {
    lang: "Haitian Creole",
    nativeLang: "Kreyòl ayisyen",
    code: "ht",
  },
  {
    lang: "Piedmontese",
    nativeLang: "Piemontèis",
    code: "pms",
  },
  {
    lang: "Bashkir",
    nativeLang: "башҡортса",
    code: "ba",
  },
  {
    lang: "Luxembourgish",
    nativeLang: "Lëtzebuergesch",
    code: "lb",
  },
  {
    lang: "Sundanese",
    nativeLang: "Sunda",
    code: "su",
  },
  {
    lang: "Irish",
    nativeLang: "Gaeilge",
    code: "ga",
  },
  {
    lang: "Icelandic",
    nativeLang: "íslenska",
    code: "is",
  },
  {
    lang: "Silesian",
    nativeLang: "ślůnski",
    code: "szl",
  },
  {
    lang: "Central Kurdish",
    nativeLang: "کوردی",
    code: "ckb",
  },
  {
    lang: "Western Frisian",
    nativeLang: "Frysk",
    code: "fy",
  },
  {
    lang: "Chuvash",
    nativeLang: "чӑвашла",
    code: "cv",
  },
  {
    lang: "Punjabi",
    nativeLang: "ਪੰਜਾਬੀ",
    code: "pa",
  },
  {
    lang: "Tagalog",
    nativeLang: "Tagalog",
    code: "tl",
  },
  {
    lang: "Aragonese",
    nativeLang: "aragonés",
    code: "an",
  },
  {
    lang: "Ido",
    nativeLang: "Ido",
    code: "io",
  },
  {
    lang: "Wu Chinese",
    nativeLang: "吴语",
    code: "wuu",
  },
  {
    lang: "Zazaki",
    nativeLang: "Zazaki",
    code: "diq",
  },
  {
    lang: "Hausa",
    nativeLang: "Hausa",
    code: "ha",
  },
  {
    lang: "Volapük",
    nativeLang: "Volapük",
    code: "vo",
  },
  {
    lang: "Scots",
    nativeLang: "Scots",
    code: "sco",
  },
  {
    lang: "Yoruba",
    nativeLang: "Yorùbá",
    code: "yo",
  },
  {
    lang: "Nepali",
    nativeLang: "नेपाली",
    code: "ne",
  },
  {
    lang: "Kannada",
    nativeLang: "ಕನ್ನಡ",
    code: "kn",
  },
  {
    lang: "Gujarati",
    nativeLang: "ગુજરાતી",
    code: "gu",
  },
  {
    lang: "Alemannic",
    nativeLang: "Alemannisch",
    code: "als",
  },
  {
    lang: "Kotava",
    nativeLang: "Kotava",
    code: "avk",
  },
  {
    lang: "Crimean Tatar",
    nativeLang: "qırımtatarca",
    code: "crh",
  },
  {
    lang: "Bavarian",
    nativeLang: "Boarisch",
    code: "bar",
  },
  {
    lang: "Interlingua",
    nativeLang: "interlingua",
    code: "ia",
  },
  {
    lang: "Sicilian",
    nativeLang: "sicilianu",
    code: "scn",
  },
  {
    lang: "Bishnupriya",
    nativeLang: "বিষ্ণুপ্রিয়া মণিপুরী",
    code: "bpy",
  },
  {
    lang: "Quechua",
    nativeLang: "Runa Simi",
    code: "qu",
  },
  {
    lang: "Igbo",
    nativeLang: "Igbo",
    code: "ig",
  },
  {
    lang: "Mongolian",
    nativeLang: "монгол",
    code: "mn",
  },
  {
    lang: "Navajo",
    nativeLang: "Diné bizaad",
    code: "nv",
  },
  {
    lang: "Balinese",
    nativeLang: "Basa Bali",
    code: "ban",
  },
  {
    lang: "Mingrelian",
    nativeLang: "მარგალური",
    code: "xmf",
  },
  {
    lang: "Sinhala",
    nativeLang: "සිංහල",
    code: "si",
  },
  {
    lang: "Mazanderani",
    nativeLang: "مازِرونی",
    code: "mzn",
  },
  {
    lang: "Northern Frisian",
    nativeLang: "Nordfriisk",
    code: "frr",
  },
  {
    lang: "Pashto",
    nativeLang: "پښتو",
    code: "ps",
  },
  {
    lang: "Tumbuka",
    nativeLang: "chiTumbuka",
    code: "tum",
  },
  {
    lang: "Ossetic",
    nativeLang: "ирон",
    code: "os",
  },
  {
    lang: "Odia",
    nativeLang: "ଓଡ଼ିଆ",
    code: "or",
  },
  {
    lang: "Samogitian",
    nativeLang: "žemaitėška",
    code: "bat-smg",
  },
  {
    lang: "Yakut",
    nativeLang: "саха тыла",
    code: "sah",
  },
  {
    lang: "Min Dong Chinese",
    nativeLang: "閩東語 / Mìng-dĕ̤ng-ngṳ̄",
    code: "cdo",
  },
  {
    lang: "Central Bikol",
    nativeLang: "Bikol Central",
    code: "bcl",
  },
  {
    lang: "Scottish Gaelic",
    nativeLang: "Gàidhlig",
    code: "gd",
  },
  {
    lang: "Buginese",
    nativeLang: "Basa Ugi",
    code: "bug",
  },
  {
    lang: "Sindhi",
    nativeLang: "سنڌي",
    code: "sd",
  },
  {
    lang: "Yiddish",
    nativeLang: "ייִדיש",
    code: "yi",
  },
  {
    lang: "Iloko",
    nativeLang: "Ilokano",
    code: "ilo",
  },
  {
    lang: "Amharic",
    nativeLang: "አማርኛ",
    code: "am",
  },
  {
    lang: "Limburgish",
    nativeLang: "Limburgs",
    code: "li",
  },
  {
    lang: "Neapolitan",
    nativeLang: "Napulitano",
    code: "nap",
  },
  {
    lang: "Gorontalo",
    nativeLang: "Bahasa Hulontalo",
    code: "gor",
  },
  {
    lang: "Maithili",
    nativeLang: "मैथिली",
    code: "mai",
  },
  {
    lang: "Faroese",
    nativeLang: "føroyskt",
    code: "fo",
  },
  {
    lang: "Upper Sorbian",
    nativeLang: "hornjoserbsce",
    code: "hsb",
  },
  {
    lang: "Basa Banyumasan",
    nativeLang: "Basa Banyumasan",
    code: "map-bms",
  },
  {
    lang: "Shan",
    nativeLang: "ၽႃႇသႃႇတႆး",
    code: "shn",
  },
  {
    lang: "Emiliano-Romagnolo",
    nativeLang: "emiliàn e rumagnòl",
    code: "eml",
  },
  {
    lang: "Achinese",
    nativeLang: "Acèh",
    code: "ace",
  },
  {
    lang: "Literary Chinese",
    nativeLang: "文言",
    code: "zh-classical",
  },
  {
    lang: "Assamese",
    nativeLang: "অসমীয়া",
    code: "as",
  },
  {
    lang: "Sanskrit",
    nativeLang: "संस्कृतम्",
    code: "sa",
  },
  {
    lang: "Walloon",
    nativeLang: "walon",
    code: "wa",
  },
  {
    lang: "Interlingue",
    nativeLang: "Interlingue",
    code: "ie",
  },
  {
    lang: "Western Armenian",
    nativeLang: "Արեւմտահայերէն",
    code: "hyw",
  },
  {
    lang: "Shona",
    nativeLang: "chiShona",
    code: "sn",
  },
  {
    lang: "Eastern Mari",
    nativeLang: "олык марий",
    code: "mhr",
  },
  {
    lang: "Ligurian",
    nativeLang: "Ligure",
    code: "lij",
  },
  {
    lang: "Zulu",
    nativeLang: "isiZulu",
    code: "zu",
  },
  {
    lang: "Fiji Hindi",
    nativeLang: "Fiji Hindi",
    code: "hif",
  },
  {
    lang: "Banjar",
    nativeLang: "Banjar",
    code: "bjn",
  },
  {
    lang: "Western Mari",
    nativeLang: "кырык мары",
    code: "mrj",
  },
  {
    lang: "Khmer",
    nativeLang: "ភាសាខ្មែរ",
    code: "km",
  },
  {
    lang: "Manipuri",
    nativeLang: "ꯃꯤꯇꯩ ꯂꯣꯟ",
    code: "mni",
  },
  {
    lang: "Hakka Chinese",
    nativeLang: "客家語/Hak-kâ-ngî",
    code: "hak",
  },
  {
    lang: "Santali",
    nativeLang: "ᱥᱟᱱᱛᱟᱲᱤ",
    code: "sat",
  },
  {
    lang: "Moroccan Arabic",
    nativeLang: "الدارجة",
    code: "ary",
  },
  {
    lang: "Tarantino",
    nativeLang: "tarandíne",
    code: "roa-tara",
  },
  {
    lang: "Pampanga",
    nativeLang: "Kapampangan",
    code: "pam",
  },
  {
    lang: "Rusyn",
    nativeLang: "русиньскый",
    code: "rue",
  },
  {
    lang: "Bhojpuri",
    nativeLang: "भोजपुरी",
    code: "bh",
  },
  {
    lang: "Northern Sotho",
    nativeLang: "Sesotho sa Leboa",
    code: "nso",
  },
  {
    lang: "Dagbani",
    nativeLang: "dagbanli",
    code: "dag",
  },
  {
    lang: "Corsican",
    nativeLang: "corsu",
    code: "co",
  },
  {
    lang: "West Flemish",
    nativeLang: "West-Vlams",
    code: "vls",
  },
  {
    lang: "Somali",
    nativeLang: "Soomaaliga",
    code: "so",
  },
  {
    lang: "Māori",
    nativeLang: "Māori",
    code: "mi",
  },
  {
    lang: "Low Saxon",
    nativeLang: "Nedersaksies",
    code: "nds-nl",
  },
  {
    lang: "Erzya",
    nativeLang: "эрзянь",
    code: "myv",
  },
  {
    lang: "Northern Sami",
    nativeLang: "davvisámegiella",
    code: "se",
  },
  {
    lang: "Sardinian",
    nativeLang: "sardu",
    code: "sc",
  },
  {
    lang: "Tibetan",
    nativeLang: "བོད་ཡིག",
    code: "bo",
  },
  {
    lang: "Veps",
    nativeLang: "vepsän kel’",
    code: "vep",
  },
  {
    lang: "Cornish",
    nativeLang: "kernowek",
    code: "kw",
  },
  {
    lang: "Gilaki",
    nativeLang: "گیلکی",
    code: "glk",
  },
  {
    lang: "Turkmen",
    nativeLang: "Türkmençe",
    code: "tk",
  },
  {
    lang: "Kabyle",
    nativeLang: "Taqbaylit",
    code: "kab",
  },
  {
    lang: "Gan Chinese",
    nativeLang: "贛語",
    code: "gan",
  },
  {
    lang: "Kinyarwanda",
    nativeLang: "Ikinyarwanda",
    code: "rw",
  },
  {
    lang: "Võro",
    nativeLang: "võro",
    code: "fiu-vro",
  },
  {
    lang: "Manx",
    nativeLang: "Gaelg",
    code: "gv",
  },
  {
    lang: "Zeelandic",
    nativeLang: "Zeêuws",
    code: "zea",
  },
  {
    lang: "Abkhazian",
    nativeLang: "аԥсшәа",
    code: "ab",
  },
  {
    lang: "Uyghur",
    nativeLang: "ئۇيغۇرچە / Uyghurche",
    code: "ug",
  },
  {
    lang: "Saraiki",
    nativeLang: "سرائیکی",
    code: "skr",
  },
  {
    lang: "Nāhuatl",
    nativeLang: "Nāhuatl",
    code: "nah",
  },
  {
    lang: "Maltese",
    nativeLang: "Malti",
    code: "mt",
  },
  {
    lang: "Talysh",
    nativeLang: "tolışi",
    code: "tly",
  },
  {
    lang: "Arpitan",
    nativeLang: "arpetan",
    code: "frp",
  },
  {
    lang: "Udmurt",
    nativeLang: "удмурт",
    code: "udm",
  },
  {
    lang: "Picard",
    nativeLang: "Picard",
    code: "pcd",
  },
  {
    lang: "Guarani",
    nativeLang: "Avañe'ẽ",
    code: "gn",
  },
  {
    lang: "Komi",
    nativeLang: "коми",
    code: "kv",
  },
  {
    lang: "Inari Sami",
    nativeLang: "anarâškielâ",
    code: "smn",
  },
  {
    lang: "Kashubian",
    nativeLang: "kaszëbsczi",
    code: "csb",
  },
  {
    lang: "Aymara",
    nativeLang: "Aymar aru",
    code: "ay",
  },
  {
    lang: "Norman",
    nativeLang: "Nouormand",
    code: "nrm",
  },
  {
    lang: "Kashmiri",
    nativeLang: "कॉशुर / کٲشُر",
    code: "ks",
  },
  {
    lang: "Lezghian",
    nativeLang: "лезги",
    code: "lez",
  },
  {
    lang: "Moksha",
    nativeLang: "мокшень",
    code: "mdf",
  },
  {
    lang: "Livvi-Karelian",
    nativeLang: "livvinkarjala",
    code: "olo",
  },
  {
    lang: "Mirandese",
    nativeLang: "Mirandés",
    code: "mwl",
  },
  {
    lang: "Kara-Kalpak",
    nativeLang: "Qaraqalpaqsha",
    code: "kaa",
  },
  {
    lang: "Lingua Franca Nova",
    nativeLang: "Lingua Franca Nova",
    code: "lfn",
  },
  {
    lang: "Old English",
    nativeLang: "Ænglisc",
    code: "ang",
  },
  {
    lang: "Saterland Frisian",
    nativeLang: "Seeltersk",
    code: "stq",
  },
  {
    lang: "Lao",
    nativeLang: "ລາວ",
    code: "lo",
  },
  {
    lang: "Friulian",
    nativeLang: "furlan",
    code: "fur",
  },
  {
    lang: "Romansh",
    nativeLang: "rumantsch",
    code: "rm",
  },
  {
    lang: "Twi",
    nativeLang: "Twi",
    code: "tw",
  },
  {
    lang: "Ladino",
    nativeLang: "Ladino",
    code: "lad",
  },
  {
    lang: "Extremaduran",
    nativeLang: "estremeñu",
    code: "ext",
  },
  {
    lang: "Papiamento",
    nativeLang: "Papiamentu",
    code: "pap",
  },
  {
    lang: "Goan Konkani",
    nativeLang: "गोंयची कोंकणी / Gõychi Konknni",
    code: "gom",
  },
  {
    lang: "Tuvinian",
    nativeLang: "тыва дыл",
    code: "tyv",
  },
  {
    lang: "Lingala",
    nativeLang: "lingála",
    code: "ln",
  },
  {
    lang: "Komi-Permyak",
    nativeLang: "перем коми",
    code: "koi",
  },
  {
    lang: "Avaric",
    nativeLang: "авар",
    code: "av",
  },
  {
    lang: "Lower Sorbian",
    nativeLang: "dolnoserbski",
    code: "dsb",
  },
  {
    lang: "Doteli",
    nativeLang: "डोटेली",
    code: "dty",
  },
  {
    lang: "Chavacano",
    nativeLang: "Chavacano de Zamboanga",
    code: "cbk-zam",
  },
  {
    lang: "Divehi",
    nativeLang: "ދިވެހިބަސް",
    code: "dv",
  },
  {
    lang: "Colognian",
    nativeLang: "Ripoarisch",
    code: "ksh",
  },
  {
    lang: "Zhuang",
    nativeLang: "Vahcuengh",
    code: "za",
  },
  {
    lang: "Ganda",
    nativeLang: "Luganda",
    code: "lg",
  },
  {
    lang: "Gagauz",
    nativeLang: "Gagauz",
    code: "gag",
  },
  {
    lang: "Russia Buriat",
    nativeLang: "буряад",
    code: "bxr",
  },
  {
    lang: "Palatine German",
    nativeLang: "Pälzisch",
    code: "pfl",
  },
  {
    lang: "Sakizaya",
    nativeLang: "Sakizaya",
    code: "szy",
  },
  {
    lang: "Pa'O",
    nativeLang: "ပအိုဝ်ႏဘာႏသာႏ",
    code: "blk",
  },
  {
    lang: "Tayal",
    nativeLang: "Tayal",
    code: "tay",
  },
  {
    lang: "Pangasinan",
    nativeLang: "Pangasinan",
    code: "pag",
  },
  {
    lang: "Pali",
    nativeLang: "पालि",
    code: "pi",
  },
  {
    lang: "Hawaiian",
    nativeLang: "Hawaiʻi",
    code: "haw",
  },
  {
    lang: "Awadhi",
    nativeLang: "अवधी",
    code: "awa",
  },
  {
    lang: "Ingush",
    nativeLang: "гӀалгӀай",
    code: "inh",
  },
  {
    lang: "Karachay-Balkar",
    nativeLang: "къарачай-малкъар",
    code: "krc",
  },
  {
    lang: "Pennsylvania German",
    nativeLang: "Deitsch",
    code: "pdc",
  },
  {
    lang: "Tongan",
    nativeLang: "lea faka-Tonga",
    code: "to",
  },
  {
    lang: "Atikamekw",
    nativeLang: "Atikamekw",
    code: "atj",
  },
  {
    lang: "Tulu",
    nativeLang: "ತುಳು",
    code: "tcy",
  },
  {
    lang: "Mon",
    nativeLang: "ဘာသာ မန်",
    code: "mnw",
  },
  {
    lang: "Aramaic",
    nativeLang: "ܐܪܡܝܐ",
    code: "arc",
  },
  {
    lang: "Fula",
    nativeLang: "Fulfulde",
    code: "ff",
  },
  {
    lang: "Tachelhit",
    nativeLang: "Taclḥit",
    code: "shi",
  },
  {
    lang: "Kalmyk",
    nativeLang: "хальмг",
    code: "xal",
  },
  {
    lang: "Xhosa",
    nativeLang: "isiXhosa",
    code: "xh",
  },
  {
    lang: "Jamaican Creole English",
    nativeLang: "Patois",
    code: "jam",
  },
  {
    lang: "Kabiye",
    nativeLang: "Kabɩyɛ",
    code: "kbp",
  },
  {
    lang: "Wolof",
    nativeLang: "Wolof",
    code: "wo",
  },
  {
    lang: "Nias",
    nativeLang: "Li Niha",
    code: "nia",
  },
  {
    lang: "Oromo",
    nativeLang: "Oromoo",
    code: "om",
  },
  {
    lang: "Angika",
    nativeLang: "अंगिका",
    code: "anp",
  },
  {
    lang: "Kabardian",
    nativeLang: "адыгэбзэ",
    code: "kbd",
  },
  {
    lang: "Novial",
    nativeLang: "Novial",
    code: "nov",
  },
  {
    lang: "Kikuyu",
    nativeLang: "Gĩkũyũ",
    code: "ki",
  },
  {
    lang: "Standard Moroccan Tamazight",
    nativeLang: "ⵜⴰⵎⴰⵣⵉⵖⵜ ⵜⴰⵏⴰⵡⴰⵢⵜ",
    code: "zgh",
  },
  {
    lang: "N’Ko",
    nativeLang: "ߒߞߏ",
    code: "nqo",
  },
  {
    lang: "Bislama",
    nativeLang: "Bislama",
    code: "bi",
  },
  {
    lang: "Tok Pisin",
    nativeLang: "Tok Pisin",
    code: "tpi",
  },
  {
    lang: "Tetum",
    nativeLang: "tetun",
    code: "tet",
  },
  {
    lang: "Aromanian",
    nativeLang: "armãneashti",
    code: "roa-rup",
  },
  {
    lang: "Lojban",
    nativeLang: "la .lojban.",
    code: "jbo",
  },
  {
    lang: "Tswana",
    nativeLang: "Setswana",
    code: "tn",
  },
  {
    lang: "Fijian",
    nativeLang: "Na Vosa Vakaviti",
    code: "fj",
  },
  {
    lang: "Kongo",
    nativeLang: "Kongo",
    code: "kg",
  },
  {
    lang: "Lak",
    nativeLang: "лакку",
    code: "lbe",
  },
  {
    lang: "Gun",
    nativeLang: "gungbe",
    code: "guw",
  },
  {
    lang: "Tahitian",
    nativeLang: "reo tahiti",
    code: "ty",
  },
  {
    lang: "Church Slavic",
    nativeLang: "словѣньскъ / ⰔⰎⰑⰂⰡⰐⰠⰔⰍⰟ",
    code: "cu",
  },
  {
    lang: "Vlax Romani",
    nativeLang: "romani čhib",
    code: "rmy",
  },
  {
    lang: "Madurese",
    nativeLang: "Madhurâ",
    code: "mad",
  },
  {
    lang: "Taroko",
    nativeLang: "Seediq",
    code: "trv",
  },
  {
    lang: "Amis",
    nativeLang: "Pangcah",
    code: "ami",
  },
  {
    lang: "Sranan Tongo",
    nativeLang: "Sranantongo",
    code: "srn",
  },
  {
    lang: "Samoan",
    nativeLang: "Gagana Samoa",
    code: "sm",
  },
  {
    lang: "Southern Altai",
    nativeLang: "алтай тил",
    code: "alt",
  },
  {
    lang: "Latgalian",
    nativeLang: "latgaļu",
    code: "ltg",
  },
  {
    lang: "Guianan Creole",
    nativeLang: "kriyòl gwiyannen",
    code: "gcr",
  },
  {
    lang: "Cherokee",
    nativeLang: "ᏣᎳᎩ",
    code: "chr",
  },
  {
    lang: "Dagaare",
    nativeLang: "Dagaare",
    code: "dga",
  },
  {
    lang: "Nyanja",
    nativeLang: "Chi-Chewa",
    code: "ny",
  },
  {
    lang: "Nigerian Pidgin",
    nativeLang: "Naijá",
    code: "pcm",
  },
  {
    lang: "Southern Sotho",
    nativeLang: "Sesotho",
    code: "st",
  },
  {
    lang: "Ghanaian Pidgin",
    nativeLang: "Ghanaian Pidgin",
    code: "gpe",
  },
  {
    lang: "Tyap",
    nativeLang: "Tyap",
    code: "kcg",
  },
  {
    lang: "Norfuk / Pitkern",
    nativeLang: "Norfuk / Pitkern",
    code: "pih",
  },
  {
    lang: "Gothic",
    nativeLang: "𐌲𐌿𐍄𐌹𐍃𐌺",
    code: "got",
  },
  {
    lang: "Swati",
    nativeLang: "SiSwati",
    code: "ss",
  },
  {
    lang: "Frafra",
    nativeLang: "farefare",
    code: "gur",
  },
  {
    lang: "Ewe",
    nativeLang: "eʋegbe",
    code: "ee",
  },
  {
    lang: "Bambara",
    nativeLang: "bamanankan",
    code: "bm",
  },
  {
    lang: "Tsonga",
    nativeLang: "Xitsonga",
    code: "ts",
  },
  {
    lang: "Venda",
    nativeLang: "Tshivenda",
    code: "ve",
  },
  {
    lang: "Batak Toba",
    nativeLang: "Batak Toba",
    code: "bbc",
  },
  {
    lang: "Cheyenne",
    nativeLang: "Tsetsêhestâhese",
    code: "chy",
  },
  {
    lang: "Rundi",
    nativeLang: "ikirundi",
    code: "rn",
  },
  {
    lang: "Fon",
    nativeLang: "fɔ̀ngbè",
    code: "fon",
  },
  {
    lang: "Inupiaq",
    nativeLang: "Iñupiatun",
    code: "ik",
  },
  {
    lang: "Adyghe",
    nativeLang: "адыгабзэ",
    code: "ady",
  },
  {
    lang: "Chamorro",
    nativeLang: "Chamoru",
    code: "ch",
  },
  {
    lang: "Wayuu",
    nativeLang: "wayuunaiki",
    code: "guc",
  },
  {
    lang: "Fanti",
    nativeLang: "mfantse",
    code: "fat",
  },
  {
    lang: "Pontic",
    nativeLang: "Ποντιακά",
    code: "pnt",
  },
  {
    lang: "Inuktitut",
    nativeLang: "ᐃᓄᒃᑎᑐᑦ / inuktitut",
    code: "iu",
  },
  {
    lang: "Paiwan",
    nativeLang: "pinayuanan",
    code: "pwn",
  },
  {
    lang: "Sango",
    nativeLang: "Sängö",
    code: "sg",
  },
  {
    lang: "Dinka",
    nativeLang: "Thuɔŋjäŋ",
    code: "din",
  },
  {
    lang: "Tigrinya",
    nativeLang: "ትግርኛ",
    code: "ti",
  },
  {
    lang: "Kalaallisut",
    nativeLang: "kalaallisut",
    code: "kl",
  },
  {
    lang: "Dzongkha",
    nativeLang: "ཇོང་ཁ",
    code: "dz",
  },
  {
    lang: "Cree",
    nativeLang: "Nēhiyawēwin / ᓀᐦᐃᔭᐍᐏᐣ",
    code: "cr",
  },
];
